var map = {
	"./actionsGroup/actionsGroup.tpl": "../components/actionsGroup/actionsGroup.tpl",
	"./avCols/avCols.php": "../components/avCols/avCols.php",
	"./changeLog/changeLog.php": "../components/changeLog/changeLog.php",
	"./comment/comment.tpl": "../components/comment/comment.tpl",
	"./component/component": "../components/component/component.js",
	"./component/component.js": "../components/component/component.js",
	"./date/date.php": "../components/date/date.php",
	"./datetime/datetime.php": "../components/datetime/datetime.php",
	"./editList/editList.php": "../components/editList/editList.php",
	"./eventsCalendar/eventsCalendar.php": "../components/eventsCalendar/eventsCalendar.php",
	"./image/config.json": "../components/image/config.json",
	"./image/image": "../components/image/image.js",
	"./image/image.js": "../components/image/image.js",
	"./image/image.tpl": "../components/image/image.tpl",
	"./itemsList/itemsList.php": "../components/itemsList/itemsList.php",
	"./optionalProductsSelection/optionalProductsSelection.tpl": "../components/optionalProductsSelection/optionalProductsSelection.tpl",
	"./password/password_strength.tpl": "../components/password/password_strength.tpl",
	"./productCard/productCard.tpl": "../components/productCard/productCard.tpl",
	"./ticketsList/ticketsList": "../components/ticketsList/ticketsList.js",
	"./ticketsList/ticketsList.js": "../components/ticketsList/ticketsList.js",
	"./ticketsList/ticketsList.tpl": "../components/ticketsList/ticketsList.tpl",
	"./widgetsList/widgetsList.php": "../components/widgetsList/widgetsList.php"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../components sync recursive ^\\.\\/.*$";